import { gql } from '@apollo/client'

const UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS_MUTATION = gql`
  mutation updateDietExcludedIngredientsDetails($id: ID!, $data: [ID!]) {
    updateDietExcludedIngredientsDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      excludedIngredients {
        id
      }
    }
  }
`

export default UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS_MUTATION
